import ModuloEnum from "@/core/utils/ModuloEnum"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum";

const componentRouterView = {
    render(c) {
        return c("router-view");
    },
};

const AdministradorRoutes = {
    path: "/administrador",
    component: componentRouterView,
    meta: {
        moduleName: "Administrador",
        icon: "gear",
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 2,
    },
    children: [
        {
            path: "painel-de-configuracao",
            name: "PainelDeConfiguracao",
            meta: {
                description: "Painel de Configuração", menu: {
                    name: "Painel de Configuração", permissao: PrivilegiosEnum.ADM_ACESSAR
                }
            },
            component: () => import("./painel-de-configuracao/PainelDeConfiguracao.vue"),
        },
    ],
};

export default AdministradorRoutes;
